import { gsap } from 'gsap';

let currentMarker = null;
let currentMobileMarker = null;
let zCounter = 20;

let isAnimating = false

const getMarkerEls = (marker) => ({
    background: marker.querySelector('.js-marker-background'),
    iconContainer: marker.querySelector('.js-marker-icon-container'),
    line: marker.querySelector('.js-marker-line'),
    content: marker.querySelector('.js-marker-content'),
    items: marker.querySelectorAll('.js-marker-content-item'),
});

// Shared dot animations — icon rotate + background expand/collapse

const animateMarkerOpen = (marker) => {
    const { background, iconContainer, line } = getMarkerEls(marker);

    marker.classList.add('open');
    marker.style.zIndex = ++zCounter;

    gsap.killTweensOf([background, iconContainer, line]);

    gsap.to(iconContainer, { rotate: 180 });

    gsap.to(line, { rotate: 90 });

    gsap.fromTo(background,
        { background: '#a4d2ed' },
        { background: '#000', duration: 0.3 }
    );

    gsap.to(background, {
        top: '-0.75rem',
        right: '-0.75rem',
        bottom: '-0.75rem',
        left: '-0.75rem',
        width: 'calc(100% + 1.5rem)',
        height: 'calc(100% + 1.5rem)',
        duration: 0.3,
    });
};

const animateMarkerClose = (marker, onComplete) => {
    if (!marker) return;

    const { background, iconContainer, line } = getMarkerEls(marker);

    marker.classList.remove('open');

    gsap.killTweensOf([background, iconContainer, line]);

    gsap.to(iconContainer, { rotate: 0, delay: 0.1 });

    gsap.to(line, { rotate: 0, delay: 0.2 });

    gsap.to(background, {
        background: '#a4d2ed',
        top: 0,
        left: 0,
        width: '2.75rem',
        height: '2.75rem',
        duration: 0.3,
        delay: 0.2,
        onComplete: () => {
            marker.style.zIndex = '';
            if (onComplete) onComplete();
        },
    });
};

// Desktop-only: also animates .js-marker-content items

const closeMarker = (marker) => {
    if (!marker) return;

    const { content, items } = getMarkerEls(marker);

    content.style.pointerEvents = 'none';

    animateMarkerClose(marker, () => {
        content.classList.add('hidden');
        content.style.pointerEvents = 'auto';
    });

    gsap.to(items, {
        opacity: 0,
        y: 5,
        duration: 0.3,
        stagger: 0.1,
    });
};

const openMarker = (marker) => {
    const { content, items } = getMarkerEls(marker);

    animateMarkerOpen(marker);

    content.classList.remove('hidden');

    gsap.fromTo(items,
        { opacity: 0, y: 5 },
        { opacity: 1, y: 0, duration: 0.3, stagger: 0.1, delay: 0.2 }
    );
};

document.querySelectorAll('.js-visualisation').forEach(el => {
    const markers = el.querySelectorAll('.js-marker');
    const mobileContents = el.querySelectorAll('.js-marker-mobile-content');
    const isHoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (isHoverDevice) {
        // Desktop — hover open/close
        markers.forEach(marker => {
            marker.addEventListener('mouseenter', () => {
                if (currentMarker && currentMarker !== marker) {
                    closeMarker(currentMarker);
                }

                currentMarker = marker;
                openMarker(marker);
            });

            marker.addEventListener('mouseleave', () => {
                closeMarker(marker);
                currentMarker = null;
            });
        });
    } else {
        // Mobile — tap to animate dot + show corresponding js-marker-mobile-content
        const getMobileContent = (marker) =>
            el.querySelector(`.js-marker-mobile-content[data-marker="${marker.dataset.marker}"]`);

        markers.forEach((marker) => {
            marker.addEventListener('click', (e) => {
                e.stopPropagation();

                if (isAnimating) return;

                const mobileContent = getMobileContent(marker);
                if (!mobileContent) return;

                isAnimating = true;

                // Tapping the same marker closes it
                if (currentMobileMarker === marker) {
                    currentMobileMarker = null;

                    animateMarkerClose(marker);

                    gsap.to(mobileContent, {
                        opacity: 0,
                        y: 5,
                        onComplete: () => {
                            mobileContent.classList.add('hidden');
                            isAnimating = false;
                        },
                    });

                    return;
                }

                // Close previously open marker, then open the new one
                const hadPreviousMarker = !!currentMobileMarker;

                if (currentMobileMarker) {
                    const prevContent = getMobileContent(currentMobileMarker);

                    animateMarkerClose(currentMobileMarker);

                    if (prevContent) {
                        gsap.to(prevContent, {
                            opacity: 0,
                            y: 5,
                            onComplete: () => prevContent.classList.add('hidden'),
                        });
                    }
                }

                currentMobileMarker = marker;

                animateMarkerOpen(marker);

                mobileContent.classList.remove('hidden');

                gsap.fromTo(mobileContent.querySelectorAll('.js-marker-content-item'),
                    { opacity: 0, y: 5 },
                    { opacity: 1, y: 0, duration: 0.3, stagger: 0.1, delay: hadPreviousMarker ? 0.5 : 0.1 }
                );

                gsap.fromTo(mobileContent,
                    { opacity: 0, y: 5 },
                    {
                        opacity: 1,
                        y: 0,
                        delay: hadPreviousMarker ? 0.4 : 0,
                        onComplete: () => { isAnimating = false; },
                    }
                );
            });
        });

        // Tap outside any marker closes the open content
        el.addEventListener('click', () => {
            if (!currentMobileMarker || isAnimating) return;

            isAnimating = true;

            const prevContent = getMobileContent(currentMobileMarker);

            animateMarkerClose(currentMobileMarker);
            currentMobileMarker = null;

            if (prevContent) {
                gsap.to(prevContent, {
                    opacity: 0,
                    y: 5,
                    onComplete: () => {
                        prevContent.classList.add('hidden');
                        isAnimating = false;
                    },
                });
            } else {
                isAnimating = false;
            }
        });
    }
});
